module.exports = __webpack_public_path__ + "img/micrositeimg.b8e6fb72.jpg";